module.exports = __webpack_public_path__ + "media/images/ui__arrowUp--dark-8a27adb4341c10016c3745972166b55d.png";